<template>
  <div>
    <h1 class="title">Страница не найдена</h1>
  </div>
</template>

<script>
export default {
  name: "NotFound"
};
</script>
